var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.6666L25 7.99992L13 1.33325L1 7.99992L13 14.6666ZM13 14.6666L21.2121 10.1043C21.9357 11.9287 22.3333 13.9178 22.3333 15.9998C22.3333 16.9349 22.2531 17.8513 22.0992 18.7424C18.6191 19.0808 15.4654 20.5341 13 22.7406C10.5346 20.5341 7.38095 19.0808 3.90082 18.7424C3.74689 17.8513 3.66667 16.9349 3.66667 15.9998C3.66667 13.9178 4.06433 11.9287 4.78783 10.1042L13 14.6666ZM7.66667 22.6665V12.6666L13 9.70362",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon3);
export default __webpack_public_path__ + "static/media/appIcon3.d45a2000491eaa4b98b6a6bd1be1e2ad.svg";
export { ForwardRef as ReactComponent };